import React, {useEffect, useState } from 'react';
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../../config.js";
import {resetPermissions, trans} from "../../utils";
import CustomDataTable from "../CustomDataTable";
import Swal from "sweetalert2";
import { ToastContainer, toast } from 'react-toastify';


const Index = (ComponentToRenderData) => {
    let history = useHistory();
    const params = useParams();
    const SystemUrl = ComponentToRenderData.SystemUrl;
    const token = localStorage.getItem('token')
    const [data, setData ] = useState([]);
    const [pm_date, setPmDate ] = useState('');
    const routeChange = path => {
        history.push(path);
    }
    const statusColor = {
        "open" : "badge-light-info",
        "wo":"badge-light-primary",
        "closed":"badge-light-success",
        "planned":"badge-light-warning",
        "delayed":"badge-light-danger",
        "replanned":"badge-light-warning",
    }
    const columns = [
        {data:"status",title:"Status"},
        {data:"date",title:"Date"},
        {data:"time",title:"Time"}
    ]
    useEffect(() => {
        axios(config.SystemUrl + `Ticket/${params.id}?include=assign_asset_item.asset_item,room_space_item,room_space_item.building,department,building,created_by_user,sub_ticket_type,ticket_type,assign_asset_item.asset_item.ecri,work_order`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => setData(result.data.data));

    }, [])

    const handleReplanForm = event =>
    {
        event.preventDefault();
        axios.delete(SystemUrl + "Ticket/" + data.id + '?status=replan&pm_date='+pm_date).then(res=>{
            Swal.fire(
                "Replan",
                'Ticket has been replanned' ,
                'success'
            ).then( jsonRes =>{
                window.location.reload()
            });
        }).catch(err =>{
            var error = err.response.data.message
            toast.error(error, { position: toast.POSITION.UPPER_RIGHT });
        } )

    }
    const ReplanDateChange = event =>
    {
        setPmDate(event.target.value)
    }
    let deleteRecord = (url, type = "Delete") => {
        //Show Sweetalert for confirmation first before submit
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warsetColumns(res.data)ning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, ${type} it!`
        }).then((result) => {
            if (result.isConfirmed) {
                //Submit to delete
                axios.delete(url)
                    .then(jsonRes => {
                        Swal.fire(
                            type == "Close"  ? `${type}d` : `${type}ed`,
                            'Ticket has been ' + type == "Close"  ? `${type}d` : `${type}ed`,
                            'success'
                        ).then( jsonRes =>{
                            window.location.reload()
                        });
                    }).catch(err=>{
                    console.log(err)
                    var error = err.response.data.message
                    toast.error(error, { position: toast.POSITION.UPPER_RIGHT });
                })
            }
        });
    }
    return (
        <div className="row">
            <div className="col-lg-3 col-xxl-4">
                <div className="card mb-5">
                    <span className={"p-20 text-center " + statusColor[data.status]}>
                       <h4>{trans('Ticket')} #{data.id}</h4>
                        <h6>{trans('Status')}: {trans(data.status)}</h6>
                   </span>
                    {data.assign_asset_item &&
                    <div className="p-2 bg-light text-center">
                        <h5>{data.assign_asset_item.asset_item.name}</h5>
                    </div>}
                </div>
            </div>
            <div className="col-lg-9 col-xxl-4">
                <div className="card mb-5">
                    <div className="card-header">
                        <div className="card-title m-0">
                            <h3 className="fw-bolder m-0">{trans('Ticket Information')}</h3>
                        </div>
                        <div className="d-flex my-4">
                            { data.status && data.status == 'open' ?
                                <>
                                    <button
                                        onClick={() => {
                                            let url = "/" + "WorkOrder" + "/Add/" + data.id;
                                            routeChange(url);
                                        }}
                                        className="btn btn-sm btn-light-primary me-3">{trans('Convert to WO')}</button>
                                    <button className="btn btn-light-success waves-effect waves-light"
                                            onClick={() => {let url = SystemUrl + "Ticket/" + data.id + '?status=closed';
                                                deleteRecord(url,"Close");}}>
                                        <span className="indicator-label">{trans('Close')}</span>
                                    </button>
                                </>
                                :''
                            }
                            { data.status && data.status == 'planned' ?
                                <>
                                    <button className="btn btn-light-info waves-effect waves-light"
                                            onClick={() => {let url = SystemUrl + "Ticket/" + data.id + '?status=open';
                                                deleteRecord(url,"Open");}}>
                                        <span className="indicator-label">{trans('Open')}</span>
                                    </button>
                                    <button className="btn btn-light-success waves-effect waves-light" data-toggle="modal" data-target="#ReplanModal">
                                        <span className="indicator-label">{trans('Replan')}</span>
                                    </button>
                                </>

                                : ""
                            }
                            { data.status && data.status == 'wo' ?
                                <button
                                    onClick={() => {
                                        let url = "/" + "WorkOrder" + "/view/" + data.work_order.id;
                                        routeChange(url);
                                    }}
                                    className="btn btn-sm btn-light-info me-3">{trans('Related WO')}</button>:''
                            }
                            { data.status && data.status == 'delayed'  &&
                            <button className="btn btn-light-success waves-effect waves-light" data-toggle="modal" data-target="#ReplanModal">
                                <span className="indicator-label">{trans('Replan')}</span>
                            </button>
                            }
                            { data.status && data.status == 'replanned'  &&
                                <>
                                    <button className="btn btn-light-info waves-effect waves-light"
                                            onClick={() => {let url = SystemUrl + "Ticket/" + data.id + '?status=open';
                                                deleteRecord(url,"Open");}}>
                                        <span className="indicator-label">{trans('Open')}</span>
                                    </button>
                                    <button className="btn btn-light-success waves-effect waves-light" data-toggle="modal" data-target="#ReplanModal">
                                        <span className="indicator-label">{trans('Replan')}</span>
                                    </button>
                                </>
                            }
                        </div>
                    </div>

                    <div className="modal fade" id="ReplanModal" tabIndex="-1" role="dialog" aria-labelledby="ReplanModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">{trans('Change PM Date')}</h5>
                                    <button type="button" className="close" data-dismiss="modal"
                                            aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form onSubmit={handleReplanForm}>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label htmlFor="date">{trans('Add New Date')} :</label>
                                            <input type="date" id="date" name="pm_date"
                                                   value={pm_date}
                                                   onChange={ReplanDateChange}
                                                   required
                                                   class="form-control flatpickr-input"
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary"
                                                data-dismiss="modal">{trans('Close')}
                                        </button>
                                        <button className="btn btn-primary"  type="submit">{trans('Submit')}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="card-body p-9">
                        <div className="row">
                            <div className="col-lg-6 col-xxl-4">
                                <div className="d-flex flex-column justify-content-center flex-row-fluid pe-11 mb-5">

                                        { data.assign_asset_item &&
                                        <>
                                            <div className="fw-bolder mt-3">{trans('Allocate Asset / Item Ref.')}</div>
                                            <div className="text-gray-600">
                                                <a href={'/RoomSpaceItem/View/'+data.room_space_item.id} target="_blank">
                                                    {trans(data.assign_asset_item.reference)}
                                                </a>
                                            </div>
                                        </>
                                        }

                                    {data.assign_asset_item   && data.assign_asset_item.asset_item.ecri.length > 0 ?
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('ECRI Name')} :</div>
                                        <div className="text-gray-600">{data.assign_asset_item.asset_item.ecri.ecri_name}</div>
                                    </> : ''
                                    }

                                    {data.assign_asset_item   && data.assign_asset_item.asset_item.ecri.length > 0 ?
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('ECRI Code')} :</div>
                                        <div className="text-gray-600">{data.assign_asset_item.asset_item.ecri.ecri_code}</div>
                                    </> : ''
                                    }

                                    {data.room_space_item  &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('Asset Location')} :</div>
                                        <div className="text-gray-600">{data.room_space_item.room_space_item_name}</div>
                                    </>
                                    }

                                    {data.room_space_item &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('Building')} :</div>
                                        <div className="text-gray-600">{data.room_space_item.building.title}</div>
                                    </>
                                    }
                                    { data.description &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('Description')} :</div>
                                        <div className="text-gray-600">{trans(data.description)}</div>

                                    </>
                                    }
                                    { data.attachment &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('Attachment')} :</div>

                                        <a href={config.BackendUrl+'/'+data.attachment} target='_blank'>{trans('Preview Attachment')}</a>

                                    </>
                                    }
                                </div>
                            </div>
                            <div className="col-lg-6 col-xxl-4">
                                <div className="d-flex flex-column justify-content-center flex-row-fluid pe-11 mb-5">
                                    {data.ticket_type && data.ticket_type.hasOwnProperty("title")  &&
                                    <>
                                        <div className="fw-bolder mt-3">{trans('Ticket Category')}:</div>
                                        <div className="text-gray-600">{trans(data.ticket_type.title)}</div>
                                    </>
                                    }
                                    {data.sub_ticket_type  && data.sub_ticket_type.hasOwnProperty("title") &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('Ticket Sub Category')}:</div>
                                        <div className="text-gray-600">{trans(data.sub_ticket_type.title)}</div>
                                        <div className="separator mb-2 mt-2"></div>
                                    </>
                                    }
                                    {data.created_by_user  &&
                                    <>

                                        <div className="fw-bolder mt-3">{trans('Created by')} :</div>
                                        <div className="text-gray-600">{data.created_by_user.name}</div>
                                    </>
                                    }
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('Created on')} :</div>
                                        <div className="text-gray-600">{data.created_at}</div>
                                    </>
                                    {data.pm_date && data.pm_date.length > 0 ?
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('PM Date')} :</div>
                                        <div className="text-gray-600">{data.pm_date}</div>
                                    </> : ""
                                    }
                                    {data.work_order && data.work_order > 0  &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('WO Reference')} :</div>
                                        <div className="text-gray-600">{data.work_order.wo_reference}</div>
                                    </>
                                    }
                                    {data.work_order  && data.work_order > 0 &&
                                    <>
                                        <div className="separator mb-2 mt-2"></div>
                                        <div className="fw-bolder mt-3">{trans('WO Created Date')} :</div>
                                        <div className="text-gray-600">{data.work_order.created_date}</div>
                                    </>
                                    }


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-5">
                    <div className="card-header cursor-pointer">
                        <div className="card-title m-0">
                            <h3 className="fw-bolder m-0">{trans('Ticket History')}</h3>
                        </div>
                    </div>
                    <div className="card-body p-9">
                        <CustomDataTable columns={columns} url={"TicketHistory?id="+params.id} table_id="TicketHistory" order={ [[0, "asc"]]} />
                    </div>
                </div>
            </div>
            <ToastContainer />

        </div>
    )
}
export default Index;
